module.exports = __webpack_public_path__ + "img/cause4Blue.010acbf3.png";